// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2MGbX","large":"styles_large__3iCGp"};